export default class APIError extends Error {
  constructor(fieldName, code, ...params) {
    super(...params);
    this.code = code;
    this.fieldName = fieldName;
  }
}
